module.exports = __webpack_public_path__ + "static/img/5.7da5d4e7.jpg";